import { useEffect, useRef } from 'react'
import {
  AvatarDropdown,
  AvatarDropdownUser,
  AvatarDropdownItem,
  Text,
  ButtonOpenApp,
  Div,
  LangSelectorMenu
} from 'ui'
import {
  Play,
  Cross
} from 'icons'
import { useTranslation } from 'react-i18next';
import { capitalize } from 'utils/common';
import useModal from 'utils/hooks/useModal';
import useResponsive from 'utils/hooks/useResponsive';
import {
  Background,
  Nav,
  CloseBtn,
  LogoStyled
} from './styles'
import { isMobile as isMobileDevice } from 'react-device-detect'
import {
  useSession,
  useLocation,
  useFlags,
} from 'hooks';
import { useHistory } from 'react-router-dom';
import { ReactComponent as DownloadSVG } from 'assets/icons/download.svg';
import { ReactComponent as SignOutSVG } from 'assets/icons/sign-out.svg';
import { ReactComponent as VideoCameraSVG } from 'assets/icons/video-camera.svg';
import Lang from './Lang';


const Menu = ({ isOpen, onClose }) => {

  const { t } = useTranslation()
  const history = useHistory()

  const { logout } = useSession();


  const { isCreators, pathname } = useLocation()
  const { TYPE_MODALS_DOWNLOAD, handleOpenModal } = useModal();
  const { isTab, isMobile } = useResponsive()

  const { isCreatorsEnabled } = useFlags()

  const sideMenuRef = useRef()

  const openModalDownloadApp = () => handleOpenModal(TYPE_MODALS_DOWNLOAD.enjoyContent)

  const handleLogout = () => {
    onClose()
    logout()
    if (isCreators) history.push('/')
  }


  useEffect(() => {
    const preventScroll = (e) => {
      if (!isOpen) return
      e.preventDefault();
      e.stopPropagation();
    }

    window.addEventListener('wheel', preventScroll, { passive: false })
    window.addEventListener('touchmove', preventScroll, { passive: false })

    return () => {
      window.removeEventListener('wheel', preventScroll, { passive: false })
      window.removeEventListener('touchmove', preventScroll, { passive: false })
    }
  }, [isOpen, onClose])


  useEffect(() => {
    if (isOpen) onClose()
  }, [pathname])


  if (isTab && !isCreators) {
    return (
      <>
        <Background isOpen={isOpen} onClick={onClose} />
        <Nav ref={sideMenuRef} isOpen={isOpen}>
          <Div
            display='flex'
            justifyContent='space-between'
          >
            {isMobile ? <LogoStyled /> : <div />}
            <CloseBtn onClick={onClose} variant='icon'>
              <Cross />
            </CloseBtn>
          </Div>

          <Div
            display='flex'
            flexDirection='column'
            justifyContent='space-between'
            flexGrow={1}
            padding='20px'
            marginTop='15px'
          >
            <div>
              <AvatarDropdownUser />

              <Div display='flex' flexDirection='column' gap={12}>

                {isCreatorsEnabled && (
                  <AvatarDropdownItem
                    to={isCreators ? '/series' : '/creators'}
                    icon={isCreators ? Play : VideoCameraSVG}
                  >
                    <Text size='sm' color='headline'>
                      {isCreators ? t('backToPlay') : t('goToCreators')}
                    </Text>
                  </AvatarDropdownItem>
                )}

                <AvatarDropdownItem onClick={openModalDownloadApp} icon={DownloadSVG}>
                  <Text size='sm' color='headline'>
                    {t("downloadApp")}
                  </Text>
                </AvatarDropdownItem>

                <Lang closeMenu={onClose} />

                <AvatarDropdownItem onClick={handleLogout} icon={SignOutSVG}>
                  <Text size='sm' color='headline'>
                    {capitalize(t("logout"))}
                  </Text>
                </AvatarDropdownItem>
              </Div>
            </div>

            {isMobileDevice && (
              <ButtonOpenApp size='large'>
                {t('openApp')}
              </ButtonOpenApp>
            )}
          </Div>
        </Nav>
      </>
    )
  }

  return (
    <AvatarDropdown>
      {({ isOpen, close }) => (
        <>
          <AvatarDropdownUser />

          <Div display='flex' flexDirection='column' padding={8} gap={4}>

            {isCreatorsEnabled && (
              <AvatarDropdownItem
                to={isCreators ? '/series' : '/creators'}
                icon={isCreators ? Play : VideoCameraSVG}
              >
                <Text size='sm' color='headline'>
                  {isCreators ? t('backToPlay') : t('goToCreators')}
                </Text>
              </AvatarDropdownItem>
            )}

            <AvatarDropdownItem
              onClick={() => {
                openModalDownloadApp()
                close()
              }}
              icon={DownloadSVG}
            >
              <Text size='sm' color='headline'>
                {t("downloadApp")}
              </Text>
            </AvatarDropdownItem>

            <Lang closeMenu={close} />

            <AvatarDropdownItem onClick={handleLogout} icon={SignOutSVG}>
              <Text size='sm' color='error'>
                {capitalize(t("logout"))}
              </Text>
            </AvatarDropdownItem>
          </Div>

        </>
      )}
    </AvatarDropdown>
  )
}

export default Menu